import axios from 'axios';
import DefaultAuthStrategy from './AuthStrategies/DefaultAuthStrategy.js';
import DefaultErrorNormalizationStrategy from './ErrorNormalizationStrategies/DefaultErrorNormalizationStrategy.js';

class ApiClientBuilder {
  authStrategy = (() => new DefaultAuthStrategy())();
  errorNormalizationStrategy = (() => new DefaultErrorNormalizationStrategy())();
  withAuthStrategy(authStrategy) {
    this.authStrategy = authStrategy;
    return this;
  }
  withErrorNormalizingStrategy(errorHandlingStrategy) {
    this.errorNormalizationStrategy = errorHandlingStrategy;
    return this;
  }
  build() {
    const axiosInstance = axios.create();

    // Setup strategies
    axiosInstance.interceptors.request.use(config => this.authStrategy.requestInterceptor(config), e => e);
    axiosInstance.interceptors.response.use(response => this.errorNormalizationStrategy.normalizeResponse(response), error => this.authStrategy.onResponseError(axiosInstance, error));
    return axiosInstance;
  }
}
var ApiClientBuilder$1 = ApiClientBuilder;

export { ApiClientBuilder$1 as default };
//# sourceMappingURL=ApiClientBuilder.js.map
